import clsx from 'clsx'
import React, { CSSProperties, FC, PropsWithChildren } from 'react'

import styles from './Chip.module.scss'

export interface ChipProps extends PropsWithChildren {
  backgroundColor?: string
  className?: string
  color?: string | 'grey' | 'error' | 'red' | 'black' | 'yellow' | 'blue' | 'greyV2' | 'greyV3'
  icon?: {
    dimensions: {
      height: number
      width: number
    }
    url: string
  }
  size?: string | 'small' | 'medium'
  style?: CSSProperties
  textColor?: string
}

const svgOverrides: Record<string, { alt: string, src: string }> = {
  blacksale: {
    alt: 'Black Sale',
    src: '/static/images/blacksale.svg',
  },
  cybermonday: {
    alt: 'Cyber Monday',
    src: '/static/images/cybermonday.svg',
  },
  lateseasonsalesvg: {
    alt: 'Late Season Sale',
    src: '/static/images/lateseasonsale.svg',
  },
  singlesday: {
    alt: 'Singles Day',
    src: '/static/images/singlesday.svg',
  },
  summersale: {
    alt: 'Summer Sale',
    src: '/static/images/summersale.svg',
  },
  trendhimclubexclusive: {
    alt: 'Trendhim Club Exclusive',
    src: '/static/images/trendhimclubexclusive.svg',
  },
}

export const Chip: FC<ChipProps> = ({
  backgroundColor,
  children,
  className,
  color,
  icon,
  size,
  style: styleProperty = {},
  textColor,
}) => {
  const style = {
    '--chipTextColor': textColor,
    '--chipBackgroundColor': backgroundColor,
    ...styleProperty,
  } as CSSProperties

  const svgOverride = svgOverrides[color || '']
  if (svgOverride) {
    return <img alt={svgOverride.alt} className={clsx(styles.svgChip, size && styles[size])} src={svgOverride.src} style={style} />
  }

  return (
    <div
      className={clsx(
        styles.chip,
        color === 'grey' && styles.grey,
        color === 'greyV2' && styles.greyV2,
        color === 'greyV3' && styles.greyV3,
        (color === 'red' || color === '20' || color === 'sale') && styles.error,
        color === 'error' && styles.error,
        color === 'black' && styles.black,
        color === 'event' && styles.event,
        color === 'blue' && styles.blue,
        color && styles[color],
        size && styles[size],
        className,
      )}
      style={style}
    >
      {icon?.url && <img alt="" className={styles.icon} src={icon.url} style={{ aspectRatio: `${icon.dimensions.width} / ${icon.dimensions.height}` }} />}
      {children}
    </div>
  )
}
